import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../service/auth/auth.service';
import { NotificationService } from '../../service/core/notification.service';
import { checkRoleAccess } from './role-guard.helper';

/** The event claims are decided by manager-admin only: a content creator, who may review the UGC, is turned away. */
@Injectable({
  providedIn: 'root'
})
export class EventClaimAuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly notificationService: NotificationService,
  ) {}

  canActivate(_route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.UNSECURE) {
      return true;
    }

    return checkRoleAccess(
      this.authService,
      this.router,
      this.notificationService,
      () => this.authService.hasAdminAccess(),
      'Non sei autorizzato ad accedere alle rivendicazioni degli eventi'
    );
  }
}
